export default __webpack_public_path__ + "static/media/glycoprotein-img.0f433b32.svg";